"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const DOM_1 = require("./DOM");
var Table;
(function (Table) {
    class Helpers {
        static triggerOnSorting(tableElement, callBack) {
            const sortingTriggers = DOM_1.DOM.Parser.getHtmlElements('sortTrigger', tableElement, true);
            for (let i = 0; i < sortingTriggers.length; i++) {
                const trigger = sortingTriggers[i];
                trigger.addEventListener('click', (event) => {
                    const sortingName = DOM_1.DOM.Parser.getDataByNameFromElement('by', trigger);
                    const sortingOrder = DOM_1.DOM.Parser.getDataByNameFromElement('order', trigger);
                    callBack({ name: sortingName, order: sortingOrder }, event);
                });
            }
        }
        static getSorting(tableElementId) {
            const tableElement = document.getElementById(tableElementId);
            if (tableElement === null) {
                return null;
            }
            const sortingActive = tableElement.querySelector('.sorting-container-down.active, .sorting-container-up.active');
            if (sortingActive === null) {
                return null;
            }
            const sortingItem = DOM_1.DOM.Parser.getHtmlElementByClass('sortTrigger', sortingActive);
            const sortingName = DOM_1.DOM.Parser.getDataByNameFromElement('by', sortingItem);
            const sortingOrder = DOM_1.DOM.Parser.getDataByNameFromElement('order', sortingItem);
            return { name: sortingName, order: sortingOrder };
        }
    }
    Table.Helpers = Helpers;
})(Table || (exports.Table = Table = {}));
